import * as React from 'react';
import { IFormField } from '../../../../interfaces/interfaces';
import Select from 'react-select';
import * as uniqid from 'uniqid';

class SelectInput extends React.Component<IFormField> {
  public props: IFormField;

  public render() {
    const { label, fieldName, options, placeholder, errorMessage, disabled, values } = this.props;
    const inputId = uniqid('input' + fieldName);
    const props = this.props;
    let selected: string = '';
    
    if (this.props.value) {
      if (props.options) {
        const option = props.options.find((o) => o.value === this.props.value);
        if (option) {
          selected = option;
        }
      }
    }

    if (selected === '') {
      if (!this.props.placeholder) {
        selected = props.options && props.options[0];
      }
    }

    const isDisabled = 'function' === typeof disabled ? disabled(fieldName, this.props.value, values) : disabled;
    return (
      <div className={'form__item form__item--select' + (errorMessage ? ' hasError' : '')}>
        <label htmlFor={inputId} className="label">
          {label}
        </label>
        <Select
          disabled={isDisabled}
          id={inputId}
          classNamePrefix="react-select"
          searchable={this.props.searchable || false}
          clearable={false}
          placeholder={placeholder}
          name={fieldName}
          value={selected}
          onChange={this.props.onChange}
          options={options}
        />
        {errorMessage && (
          <p className={'form__error'}>{errorMessage}</p>
        )}
      </div>
    );
  }
}

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/components/Select.tsx